import classes from "./questionTypes.module.css";
import formClasses from "../../criteriaSubmission.module.css";
import {
  selectFormData,
  setFormData,
  selectFormType,
} from "../../../../slices/form";
import { useDispatch, useSelector } from "react-redux";
import MultipleChoiceCheckbox from "./multipleChoiceCheckbox";
import QuestionCount from "./questionCount";
import { Box } from "@mui/material";
import ToolsTooltip from "../../toolsTooltip";

export const checkboxesOpenBook = [
  { name: "theme", display: "Theme" },
  { name: "analysis", display: "Analysis" },
  { name: "structure", display: "Structure" },
  { name: "tone", display: "Tone" },
  { name: "vocabulary", display: "Vocab" },
];
export const checkboxesClosedBook = [
  { name: "knowledge", display: "Knowledge" },
  { name: "comprehension", display: "Comprehension" },
  { name: "analysis", display: "Analysis" },
  { name: "application", display: "Application" },
];
export const checkboxesMath = [
  { name: "fluency", display: "Fluency" },
  { name: "concept", display: "Concepts" },
  { name: "application", display: "Applications" },
  { name: "reasoning", display: "Reasoning" },
];

const QuestionsTypes = () => {
  const formData = useSelector(selectFormData);
  const dispatch = useDispatch();
  const subject = formData?.subject || "English";
  const formType = useSelector(selectFormType);

  const { questions, show_text } = formData || {};
  const { mc_quantity, ff_quantity, tf_quantity, fb_quantity } = questions || {};

  const incrementDecrement = (name, newValue) => {
    if (name === "multipleChoice") {
      dispatch(
        setFormData({
          questions: {
            ...questions,
            mc_quantity: newValue,
          },
        })
      );
    } else if (name === "shortAnswer") {
      dispatch(
        setFormData({
          questions: {
            ...questions,
            ff_quantity: newValue,
          },
        })
      );
    } else if (name === "trueFalse") {
      dispatch(
        setFormData({
          questions: {
            ...questions,
            tf_quantity: newValue,
          },
        })
      );
    } else if (name === "fillInTheBlank") {
      dispatch(
        setFormData({
          questions: {
            ...questions,
            fb_quantity: newValue,
          },
        })
      );
    }
  };

  return (
    <div style={{ width: "100%" }}>
      <div >
        {(show_text === "Open book") && (formType === "assessment") ? (
          <Box className={classes.sectionBlock}>
            <div className={formClasses["input-container"]}>
              <label className={formClasses.formLabel} htmlFor="question_scope_passage_only">
                Question Scope:
              </label>
            </div>
              <Box
                sx={{
                  display: "flex",
                flexDirection: "column",
                gap: "10px",
              }}
            >
              <div className={classes.individualCheckbox}>
                <label className={classes.container}>
                  <input
                    type="radio"
                    value="background_knowledge"
                    checked={questions?.question_scope_passage_only === false}
                    onChange={() =>
                      dispatch(
                        setFormData({
                          questions: {
                            ...questions,
                            question_scope_passage_only: false,
                          },
                        })
                      )
                    }
                  />
                  <span className={classes.checkmark}></span>
                </label>
                <span>
                  Include relevant background/contextual knowledge
                </span>
              </div>
              <div className={classes.individualCheckbox}>
                <label className={classes.container}>
                  <input
                    type="radio"
                    value="passage_only"
                    checked={questions?.question_scope_passage_only !== false}
                    onChange={() =>
                      dispatch(
                        setFormData({
                          questions: {
                            ...questions,
                            question_scope_passage_only: true,
                          },
                        })
                      )
                    }
                  />
                  <span className={classes.checkmark}></span>
                </label>
                <span>Only information in the provided content</span>
              </div>
            </Box>
          </Box>
        ) : null}
  <div className={`${classes.inputContainer}`}>
          <div>
            <label className={formClasses.formLabel} htmlFor="questionTypes">
              Question types:&nbsp;
            </label>
            <ToolsTooltip name={"questions"} />
          </div>
        </div>
    <Box
          sx={{
            display: "flex",
            gap: "20px",
            alignItems: { xs: "", lg: "center" },
            width: "100%",
            flexDirection: { xs: "column", lg: "row" },
      marginBottom: "32px",
          }}
        >
          <Box>
            {subject === "Math" ? (
              <Box
                sx={{
                  display: "flex",
                  gap: "20px",
                  alignItems: "center",
                  flexDirection: { xs: "column", md: "row" },
                }}
              >
                {checkboxesMath.map((box, index) => (
                  <MultipleChoiceCheckbox key={`${box}${index}`} box={box} />
                ))}
              </Box>
            ) : show_text === "Open book" ? (
              <>
                <Box
                  sx={{
                    display: "flex",
                    gap: "20px",
                    alignItems: "center",
                    flexDirection: { xs: "column", md: "row" },
                  }}
                >
                  {checkboxesOpenBook.map((box, index) => (
                    <MultipleChoiceCheckbox key={`${box}${index}`} box={box} />
                  ))}
                </Box>
              </>
            ) : (
              <Box
                sx={{
                  display: "flex",
                  gap: "20px",
                  alignItems: "center",
                  flexDirection: { xs: "column", md: "row" },
                }}
              >
                {checkboxesClosedBook.map((box, index) => (
                  <MultipleChoiceCheckbox key={`${box}${index}`} box={box} />
                ))}
              </Box>
            )}
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            gap: "20px",
            alignItems: "center",
            marginTop: "30px",
          }}
        >
          <QuestionCount
            name={"multipleChoice"}
            initialValue={mc_quantity}
            incrementDecrement={incrementDecrement}
          />
          <p style={{ fontWeight: 600 }}>Multiple-choice</p>
        </Box>

        <div
          style={{ marginTop: "10px" }}
          className={classes.individualCheckbox}
        >
          <label className={classes.container}>
            <input
              checked={formData?.questions?.mc_options === 5 ? true : false}
              name={`optionsCount`}
              type="checkbox"
              onChange={(e) => {
                dispatch(
                  setFormData({
                    questions: {
                      ...questions,
                      mc_options: e.target.checked ? 5 : 4,
                    },
                  })
                );
              }}
            />
            <span className={classes.checkmark}></span>
          </label>
          <span>Generate 5 answer options (default is 4)</span>
        </div>

        <div style={{ marginTop: "20px" }} className={classes.mainSection}>
          <QuestionCount
            name={"shortAnswer"}
            initialValue={ff_quantity}
            incrementDecrement={incrementDecrement}
          />
          <p style={{ fontWeight: 600 }}>Short-answer</p>
        </div>

        <div style={{ marginTop: "20px" }} className={classes.mainSection}>
          <QuestionCount
            name={"trueFalse"}
            initialValue={tf_quantity || 0}
            incrementDecrement={incrementDecrement}
          />
          <p style={{ fontWeight: 600 }}>True/False</p>
        </div>

        <div style={{ marginTop: "20px" }} className={classes.mainSection}>
          <QuestionCount
            name={"fillInTheBlank"}
            initialValue={fb_quantity || 0}
            incrementDecrement={incrementDecrement}
          />
          <p style={{ fontWeight: 600 }}>Fill-in-the-Blank</p>
        </div>
      </div>
    </div>
  );
};

export default QuestionsTypes;
